module.exports = __webpack_public_path__ + "img/persona1.a01c6088.jpg";